import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { SkipLink } from '../components/SkipLink';
import { LocaleProvider, useT } from '../lib/i18n';
import { SoundHydrator } from '../lib/sounds';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const t = useT();
  return (
    <>
      <LocaleProvider />
      <SoundHydrator />
      <SkipLink>{t('a11y.skip')}</SkipLink>
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  );
}
